import { render, staticRenderFns } from "./enterpriseDetail.vue?vue&type=template&id=61e0a48f&scoped=true"
import script from "./enterpriseDetail.vue?vue&type=script&lang=js"
export * from "./enterpriseDetail.vue?vue&type=script&lang=js"
import style0 from "./enterpriseDetail.vue?vue&type=style&index=0&id=61e0a48f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e0a48f",
  null
  
)

export default component.exports